import { CmsApi } from './cms-api';

const cmsApi = new CmsApi();

export { cmsApi };
